import { Text } from "$components";

export const data = [
  {
    x: 1,
    y: "du texte",
    z: 42,
  },
  {
    x: 2,
    y: "batail-log batail-log",
    z: 42,
  },
  {
    x: 3,
    y: "blabla",
    z: 42,
  },
  {
    x: 4,
    y: "blabla",
    z: 42,
  },
  {
    x: 5,
    y: "j'écris un peu pour remplir",
    z: 42,
  },
  {
    x: 6,
    y: "blabla",
    z: 42,
  },
  {
    x: 7,
    y: "du texte un peu plus long",
    z: 42,
  },
  {
    x: 8,
    y: "",
    z: 42,
  },
  {
    x: 9,
    y: "blabla",
    z: 42,
  },
  {
    x: 10,
    y: "du texte",
    z: 42,
  },
  {
    x: 11,
    y: "blabla",
    z: 42,
  },
  {
    x: 12,
    y: "lorem ipsum texte long",
    z: 42,
  },
  {
    x: 13,
    y: "blabla",
    z: 42,
  },
  {
    x: 14,
    y: "text text test test du texte",
    z: 42,
  },
  {
    x: 15,
    y: "blabla",
    z: 42,
  },
];

export const columns = [
  {
    id: "x",
    Header: "Valeur X",
    Cell: ({
      row: {
        original: { x },
      },
    }: any) => <Text type="important">{x}</Text>,
  },
  {
    id: "y",
    Header: "Valeur Y",
    Cell: ({
      row: {
        original: { y },
      },
    }: any) => <Text>{y}</Text>,
    z: 42,
  },
  {
    id: "Z",
    Header: "Valeur Z",
    Cell: ({
      row: {
        original: { z },
      },
    }: any) => (
      <Text>
        <b>{z}</b>
      </Text>
    ),
  },
  {
    id: "latest_column",
    Header: "",
  },
];
